import { GET_ACCOUNT_AGREEMENTS_SUCCESS } from 'stash/actions/api/account';
const accountAgreements = (state = {}, action) => {
	switch (action.type) {
		case GET_ACCOUNT_AGREEMENTS_SUCCESS: {
			return {
				...action.response.agreement,
			};
		}
		default:
			return state;
	}
};

export default accountAgreements;
